import React from 'react';
import {useHistory} from 'react-router-dom';
import {useCurrentUser} from '../hooks/user';
import {fetchUserInfo} from '../store/user/actions';
import {useDispatch} from 'react-redux';
import {createOffersManagementUrl} from '../utils/navigation';
import {AlertType} from '../common/types';
import {openAppReviewDialog} from '../store/offers/reducers/actionDialogs';

interface IosPushNotifierProps {
}

const IosPushHandler: React.FC<IosPushNotifierProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const getPushCategory = (data: any): string | null => {
    if (typeof data === 'string') {
      return data;
    }

    return data?.category ||
      data?.threadId ||
      data?.type ||
      data?.customData?.category ||
      data?.payload?.customData?.category ||
      null;
  };

  const triggerAppReviewForPush = (data: any) => {
    const category = getPushCategory(data);
    alert(category);

    if ([
      'payment',
      'payment_gift',
      'pro_subscription',
      'status_level',
    ].includes(category || '')) {
      dispatch(openAppReviewDialog(`push_${category}`));
    }
  };

  const updateUserInfo = () => {
    dispatch(fetchUserInfo());
  }

  // @ts-ignore
  window.handlePushNotification = function (data: any) {
    console.log('Push notification received:', data);
    alert('Push notification received: ' + JSON.stringify(data));
    triggerAppReviewForPush(data);
    if(getPushCategory(data) == 'payment'){
      history.push('/payment');
    }
  }
  // @ts-ignore
  window.handleIosPaymentSuccess = function (data: any) {
    updateUserInfo();
    dispatch(openAppReviewDialog('ios_payment_success'));
    history.push(createOffersManagementUrl({alertType: AlertType.PaymentSuccessful, alertPayload: data}));
    console.log('Payment success received:', data);
  }
  return null;
};

export default IosPushHandler;
